import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { onDemoLocaleChange, onDemoModeChange } from '../../anonymization';

/**
 * Pendant V2 du remontage fait par Base.js : les noms fictifs du mode démo ne
 * sont calculés qu'à la livraison des snapshots par le proxy Firestore. Sans
 * remontage, basculer le mode démo (ou changer de langue en mode démo) laisse
 * les vues /v2 sur leurs données déjà chargées — l'en-tête passe en « Mode
 * démo » mais la page garde les vrais noms (ou l'inverse au retour).
 *
 * Le shell persistant (barre latérale, en-tête) reste monté : seules les
 * routes enfants sont remontées, elles relisent leurs données via le proxy.
 */
export default function DemoModeRemountBoundary({ children }) {
    const [demoEpoch, setDemoEpoch] = useState(0);

    useEffect(() => {
        const remountViews = () => setDemoEpoch((epoch) => epoch + 1);
        const unsubscribeDemoMode = onDemoModeChange(remountViews);
        const unsubscribeDemoLocale = onDemoLocaleChange(remountViews);
        return () => {
            unsubscribeDemoMode();
            unsubscribeDemoLocale();
        };
    }, []);

    return <React.Fragment key={demoEpoch}>{children}</React.Fragment>;
}

DemoModeRemountBoundary.propTypes = { children: PropTypes.node.isRequired };
